export const zh = {
  // Navigation
  home: "首页",
  about: "关于我们",
  tours: "旅游",
  deals: "优惠",
  testimonials: "评价",
  blog: "博客",
  contact: "联系我们",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "欢迎来到斯里兰卡",
  welcomeSubtitle: "发现印度洋明珠的美丽",
  exploreButton: "探索旅游",
  learnMoreButton: "了解更多",
  
  // About page
  aboutTitle: "关于我们",
  aboutSubtitle: "您在斯里兰卡值得信赖的旅行伙伴",
  aboutDescription: "我们专门为斯里兰卡创造难忘的旅行体验，从原始海滩到古老寺庙。",
  
  // Tours page
  toursTitle: "我们的旅游",
  toursSubtitle: "发现令人惊叹的目的地",
  bookNow: "立即预订",
  viewDetails: "查看详情",
  
  // Contact page
  contactTitle: "联系我们",
  contactSubtitle: "与我们联系",
  name: "姓名",
  email: "电子邮件",
  message: "消息",
  send: "发送消息",
  phone: "电话",
  address: "地址",
  
  // Testimonials
  testimonialsTitle: "客户评价",
  testimonialsSubtitle: "真实旅行者的真实体验",
  
  // Blog
  blogTitle: "旅行博客",
  blogSubtitle: "最新的旅行故事和提示",
  readMore: "阅读更多",
  
  // Common
  loading: "加载中...",
  error: "发生错误",
  success: "成功！",
  close: "关闭",
  submit: "提交",
  cancel: "取消",
  
  // Language selector
  selectLanguage: "选择语言",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  russian: "Русский",
  chinese: "中文",
  hindi: "हिन्दी",
  arabic: "العربية",
  
  // About Us Page
  whyChooseTitle: "为什么选择斯里亚特拉旅游？",
  whyChooseSubtitle: "我们致力于为您提供最佳的旅行体验，提供卓越的服务和个性化套餐。",
  personalizedTitle: "个性化旅行规划",
  personalizedDesc: "我们根据您的独特需求定制每次旅行，确保独一无二的旅行体验。",
  customerSupportTitle: "24/7客户支持",
  customerSupportDesc: "我们敬业的旅行专家全天候为您提供任何问题的帮助。",
  destinationsTitle: "精选目的地",
  destinationsDesc: "探索精心挑选的最佳目的地，为您提供难忘的体验。",
  priceGuaranteeTitle: "最佳价格保证",
  priceGuaranteeDesc: "我们在不妥协旅行体验质量的前提下提供有竞争力的价格。",
  luxuryTitle: "奢华与舒适",
  luxuryDesc: "享受豪华住宿和无缝旅行安排，获得极致舒适。",
  guidesTitle: "专业导游",
  guidesDesc: "我们知识渊博且友好的导游确保您充分利用旅行。",
  
  // Contact Page
  getInTouchTitle: "与斯里亚特拉旅游联系",
  loveToHearTitle: "我们很想听到您的消息",
  loveToHearDesc: "无论您对我们的旅游、价格或其他任何问题有疑问，我们的团队都准备回答您的所有问题。",
  office: "办公室",
  phone: "电话",
  support: "支持",
  email: "电子邮件",
  officeAddress: "Watabage Junction, Panadura, Sri Lanka",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "给我们发送消息",
  contactFormDesc: "填写下面的表格，我们会尽快回复您。",
  namePlaceholder: "您的姓名",
  emailPlaceholder: "您的电子邮件",
  phonePlaceholder: "您的电话号码",
  messagePlaceholder: "您的消息",
  submitButton: "发送消息",
  submitting: "发送中...",
  messageSent: "消息发送成功！",
  messageError: "发送消息失败。请重试。",
  
  // Testimonials Page
  customerReviewsTitle: "客户评价",
  customerReviewsSubtitle: "与我们一起探索斯里兰卡的真实旅行者的真实体验",
  
  // Blog Page
  travelBlogTitle: "旅行博客",
  travelBlogSubtitle: "来自我们在斯里兰卡冒险的最新旅行故事、提示和见解",
  
  // Tours Page
  ourToursTitle: "我们的旅游",
  ourToursSubtitle: "发现令人惊叹的目的地和难忘的体验",
  
  // Deals Page
  specialDealsTitle: "特别优惠",
  specialDealsSubtitle: "我们最佳旅游的独家优惠和折扣",
  
  // Tour Content
  culturalTourTitle: "斯里兰卡文化之旅",
  culturalTourDesc: "在这个文化之旅中体验斯里兰卡丰富的遗产和历史遗址。",
  wildlifeTourTitle: "野生动物探险",
  wildlifeTourDesc: "探索斯里兰卡著名的野生动物公园，在自然栖息地观察异国动物。",
  beachTourTitle: "海滩度假",
  beachTourDesc: "在斯里兰卡最美丽的海滩上放松，享受清澈的海水和金色沙滩。",
  hillCountryTourTitle: "山区探险",
  hillCountryTourDesc: "发现斯里兰卡山脉、瀑布和茶园的美景。",
  honeymoonTourTitle: "豪华蜜月套餐",
  honeymoonTourDesc: "在斯里兰卡最好的度假村享受浪漫奢华的蜜月体验。",
  adventureTourTitle: "冒险与徒步旅行",
  adventureTourDesc: "在斯里兰卡开始激动人心的徒步冒险和户外活动。",
  
  // Deal Content
  exclusiveHoneymoonTitle: "独家斯里兰卡蜜月套餐",
  exclusiveHoneymoonDesc: "享受浪漫度假、海滩度假村和文化体验的豪华蜜月。",
  adventureWildlifeTitle: "冒险与野生动物之旅",
  adventureWildlifeDesc: "通过激动人心的狩猎和自然探险探索斯里兰卡的荒野。",
  luxuryBeachTitle: "豪华海滩度假",
  luxuryBeachDesc: "在最美丽的海滩上放松，享受水上运动，体验一流的款待。",
  culturalHeritageTitle: "文化遗产之旅",
  culturalHeritageDesc: "参观斯里兰卡的联合国教科文组织世界遗产、古老寺庙和充满活力的城市。",
  budgetFamilyTitle: "经济型家庭度假",
  budgetFamilyDesc: "为所有年龄段提供激动人心活动的经济实惠家庭友好套餐。",
  ultimateAdventureTitle: "终极冒险之旅",
  ultimateAdventureDesc: "在斯里兰卡令人叹为观止的风景中进行徒步、漂流和冒险运动。",
  
  // Blog Content
  exploringBeautyTitle: "探索斯里兰卡的美丽",
  exploringBeautyExcerpt: "在这个全面的旅行指南中发现斯里兰卡令人叹为观止的风景、丰富的历史和文化奇迹。",
  bestBeachesTitle: "斯里兰卡最佳海滩",
  bestBeachesExcerpt: "从金色沙滩到令人惊叹的绿松石海水，探索斯里兰卡最佳海滩目的地，享受完美度假。",
  wildlifeSafariTitle: "野生动物探险",
  wildlifeSafariExcerpt: "体验在斯里兰卡著名国家公园发现大象、豹子和异国鸟类的刺激。",
  
  // Testimonial Content
  johnReview: "我们的斯里兰卡之旅绝对精彩！规划和组织都很完美，我们在整个旅程中都得到了很好的照顾。强烈推荐斯里亚特拉旅游！",
  emmaReview: "真正难忘的体验！从美丽的海滩到令人惊叹的文化遗址，一切都计划得很完美。迫不及待想再次访问！",
  carlosReview: "我预订过的最好的旅行社！一切都组织得很好，导游知识渊博且友好。感谢您提供的惊人体验！",
  sophiaReview: "一次无缝且难忘的旅行！团队很专业，行程安排得很好。强烈推荐任何访问斯里兰卡的人选择斯里亚特拉旅游。",
  
  // Common Labels
  activities: "活动",
  duration: "持续时间",
  price: "价格",
  workingHours: "工作时间",
  workingHoursText: "周一 – 周五: 上午9:00 – 下午6:00",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "斯里兰卡亮点",
  fiveDayHighlightsSubtitle: "亮点：卡图纳亚克、锡吉里耶、康提、埃拉、加勒。通过斯里兰卡必游目的地的紧凑之旅。",
  bookNow: "立即预订",
  
  // Katunayake
  day1Title: "抵达",
  katunayakeTitle: "卡图纳亚克",
  katunayakeStay: "卡图纳亚克附近的舒适住宿",
  katunayakeActivities: "活动",
  katunayakeArrival: "抵达班达拉奈克国际机场",
  katunayakeMeetGreet: "迎接和转机到附近住宿",
  katunayakeNegombo: "可选访问尼甘布海滩（时间允许）",
  katunayakeRest: "休息和从飞行中恢复",
  katunayakeLocation: "卡图纳亚克 - 班达拉奈克国际机场",
  katunayakeDescription: "在机场附近舒适的第一晚开始您的斯里兰卡亮点之旅。",
  
  // Sigiriya
  day2Title: "锡吉里耶",
  sigiriyaTitle: "锡吉里耶",
  sigiriyaStay: "锡吉里耶的宾馆",
  sigiriyaTransfer: "转机到锡吉里耶",
  sigiriyaClimb: "攀登锡吉里耶岩石堡垒",
  sigiriyaExplore: "探索水花园和壁画",
  sigiriyaVillage: "村庄体验或骑自行车（可选）",
  sigiriyaLocation: "锡吉里耶岩石堡垒",
  sigiriyaDescription: "具有全景视野的标志性联合国教科文组织世界遗产。",
  
  // Kandy
  day3Title: "康提",
  kandyTitle: "康提",
  kandyStay: "康提的酒店",
  kandyTransfer: "转机到康提",
  kandyTemple: "佛牙寺",
  kandyGardens: "皇家植物园，佩拉德尼亚",
  kandyLake: "康提湖漫步和当地市场",
  kandyLocation: "佛牙寺，康提",
  kandyDescription: "拥有神圣遗产和郁郁葱葱花园的文化首都。",
  
  // Ella
  day4Title: "埃拉",
  ellaTitle: "埃拉",
  ellaStay: "埃拉的舒适住宿",
  ellaTrain: "风景如画的火车之旅到埃拉",
  ellaPeak: "小亚当峰徒步",
  ellaBridge: "九拱桥观景点",
  ellaExplore: "探索城镇的茶乡氛围",
  ellaLocation: "埃拉附近的风景火车",
  ellaDescription: "凉爽气候的山地度假胜地，拥有令人叹为观止的山景。",
  
  // Galle
  day5Title: "加勒",
  galleTitle: "加勒",
  galleStay: "加勒的酒店（或晚出发）",
  galleTransfer: "转机到加勒",
  galleFort: "探索联合国教科文组织列出的加勒堡垒",
  galleLighthouse: "灯塔和城墙漫步",
  galleCafes: "咖啡馆、精品店和海景",
  galleContinue: "继续到机场或延长海滩住宿",
  galleLocation: "加勒堡垒城墙和灯塔",
  galleDescription: "历史悠久的沿海魅力，结束您的亮点之旅",
  
  // Colombo Tour
  threeDayColomboTitle: "科伦坡之旅 - 斯里兰卡",
  threeDayColomboSubtitle: "通过豪华酒店、文化访问、购物和海边放松体验科伦坡的最佳。",
  
  // Colombo
  dayOneTitle: "抵达",
  dayTwoTitle: "城市观光", 
  dayThreeTitle: "出发",
  
  // Day One Activities
  colomboArrival: "抵达班达拉奈克国际机场",
  colomboTransfer: "转机到酒店并办理入住",
  colomboFort: "探索科伦坡堡垒区 – 殖民建筑、市场和购物",
  colomboDinner: "酒店餐厅晚餐和过夜。",
  
  // Day Two Activities
  colomboBreakfast: "酒店早餐",
  colomboTemple: "参观甘加拉马亚寺和博物馆",
  colomboLunch: "当地餐厅午餐",
  colomboMuseum: "下午参观国家博物馆和维哈拉马哈德维公园",
  colomboOvernight: "晚餐和过夜。",
  
  // Day Three Activities
  colomboRelax: "在加勒菲斯绿地放松并观看海洋",
  colomboShopping: "在奥德尔或赤脚画廊购物",
  colomboPrepare: "准备出发",
  colomboCheckout: "退房并转机到机场。",
  
  // Hotels
  cinnamonGrand: "肉桂大酒店科伦坡",
  shangriLa: "香格里拉科伦坡",
  kingsbury: "金斯伯里科伦坡",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "经济套餐（斯里兰卡亮点）",
  fiveDayBudgetPackSubtitle: "亮点",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "经济",
  fiveDayBudgetPackHighlights: "亮点",
  fiveDayBudgetPackCulture: "文化",
  fiveDayBudgetPackHistory: "历史",
  fiveDayBudgetPackNature: "自然",
  fiveDayBudgetPackPrice: "每人起价US $650",
  moreInformation: "更多信息 ➜",
  
  threeDayColomboCityTitle: "科伦坡城市体验",
  threeDayColomboCitySubtitle: "城市观光",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "城市观光",
  threeDayColomboCityCulture: "文化",
  threeDayColomboCityShopping: "购物",
  threeDayColomboCityLuxury: "豪华酒店",
  threeDayColomboCitySightseeing: "观光",
  threeDayColomboCityPrice: "每人起价US $350",
  
  familyTripTitle: "斯里兰卡家庭之旅",
  familyTripSubtitle: "家庭套餐",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "野生动物",
  familyTripNature: "自然",
  familyTripCulture: "文化",
  familyTripHistory: "历史",
  familyTripPrice: "每人起价US $850",
  
  bestOfSriLankaTitle: "斯里兰卡精华",
  bestOfSriLankaSubtitle: "综合",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "海滩",
  bestOfSriLankaWildlife: "野生动物",
  bestOfSriLankaNature: "自然",
  bestOfSriLankaCulture: "文化",
  bestOfSriLankaPrice: "每人起价US $1250",
  
  romanticGetawayTitle: "斯里兰卡浪漫度假",
  romanticGetawaySubtitle: "浪漫套餐",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "自然",
  romanticGetawayBeach: "海滩",
  romanticGetawayWildlife: "野生动物",
  romanticGetawayHistory: "历史",
  romanticGetawayPrice: "每人起价US $1700",
  
  // Why Choose Us
  whyChooseUsTitle: "为什么选择我们",
  whyChooseUsSubtitle: "许多人选择我们作为他们首选的旅游目的地管理公司，您也会因为以下原因选择我们。",
  
  whyChooseUsReason1: "我们是斯里兰卡顶级目的地管理公司之一。",
  whyChooseUsReason2: "我们是斯里兰卡领先的旅游运营商之一。",
  whyChooseUsReason3: "我们为旅行者和旅游代理商提供完整的旅游套餐。",
  whyChooseUsReason4: "我们拥有一支由40名代表组成的充满激情和专业的团队，对斯里兰卡旅游业有广泛的了解。",
  whyChooseUsReason5: "我们是斯里兰卡领先的旅游代理商之一。",
  whyChooseUsReason6: "我们为客户提供定制和专业的旅游。",
  whyChooseUsReason7: "我们是斯里兰卡领先的旅游代理商，为异国情调的目的地提供旅游和度假套餐。",
  whyChooseUsReason8: "我们为客户提供24/7客户支持。",
  
  readMore: "阅读更多",
  
  // How It Works
  howItWorksTitle: "如何运作？",
  
  // Common UI elements
  days: "天",
  from: "起价",
  perPerson: "每人",
  
  step1Title: "1. 立即咨询",
  step1Time: "5分钟",
  step1FillingForm: "填写网络表格",
  step1WebChat: "网络实时聊天",
  step1Email: "电子邮件",
  step1Call: "致电我们",
  
  step2Title: "2. 连接旅行专家",
  step2Time: "30分钟",
  step2Discuss: "讨论您的需求",
  step2FreeAdvice: "免费专家旅行建议",
  step2Support: "24/7支持",
  
  step3Title: "3. 收到3个旅行选项",
  step3Discuss: "讨论变更",
  step3Finalise: "确定旅行计划",
  step3Pay: "支付10%",
  
  step4Title: "4. 收到您的旅行确认",
  step4FillingForm: "填写网络表格",
  step4Satisfaction: "100%满意保证",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "完整的斯里兰卡环线游",
  completeSriLankaSubtitle: "全面",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "全面",
  completeSriLankaHighlights: "亮点",
  completeSriLankaCulture: "文化",
  completeSriLankaHistory: "历史",
  completeSriLankaNature: "自然",
  completeSriLankaBeach: "海滩",
  completeSriLankaPrice: "每人US $1850起",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "完整的斯里兰卡环线游",
  completeSriLankaCircuitSubtitle: "通过这个涵盖所有主要目的地的全面旅程，体验斯里兰卡的完整美丽。",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "阿努拉德普勒",
  ancientCityStay: "阿努拉德普勒酒店",
  ancientCityTransfer: "转至阿努拉德普勒",
  ancientCityExplore: "探索古代遗址和佛塔",
  ancientCityTemple: "参观圣菩提树",
  ancientCityMuseum: "参观考古博物馆",
  ancientCityLocation: "阿努拉德普勒古城",
  ancientCityDescription: "发现斯里兰卡的古都联合国教科文组织世界遗产地。",
  
  // Nuwara Eliya
  day5Title: "努沃勒埃利耶",
  nuwaraEliyaTitle: "努沃勒埃利耶",
  nuwaraEliyaStay: "努沃勒埃利耶酒店",
  nuwaraEliyaTransfer: "转至努沃勒埃利耶",
  nuwaraEliyaTea: "茶园和工厂游览",
  nuwaraEliyaLake: "格雷戈里湖乘船",
  nuwaraEliyaExplore: "探索小英格兰",
  nuwaraEliyaLocation: "努沃勒埃利耶茶乡",
  nuwaraEliyaDescription: "体验小英格兰凉爽的气候和茶乡的魅力。",
  
  // Ella (Second Day)
  day6Title: "埃拉",
  day7Title: "埃拉延长",
  ellaWaterfall: "参观拉瓦纳瀑布",
  ellaTea: "茶园游览",
  ellaRelax: "放松并享受山景",
  ellaLocal: "当地村庄体验",
  ellaDay2Description: "在埃拉的第二天探索瀑布和茶乡。",
  
  // Mirissa
  day8Title: "米瑞莎",
  mirissaTitle: "米瑞莎",
  mirissaStay: "米瑞莎海滩度假村",
  mirissaTransfer: "转至米瑞莎",
  mirissaBeach: "在米瑞莎海滩放松",
  mirissaWhale: "观鲸之旅（季节性）",
  mirissaRelax: "海滩放松和日落",
  mirissaLocation: "米瑞莎海滩",
  mirissaDescription: "享受美丽的海滩和观鲸机会。",
  
  // Mirissa (Second Day)
  day9Title: "米瑞莎延长",
  mirissaSnorkel: "浮潜和水上运动",
  mirissaDiving: "水肺潜水（可选）",
  mirissaSunset: "日落海滩漫步",
  mirissaDay2Description: "在米瑞莎的第二天进行水上活动和海滩放松。",
  
  // Galle
  day10Title: "加勒",
  
  // Galle (Second Day)
  day11Title: "加勒延长",
  galleShopping: "在加勒堡购物",
  galleMuseum: "参观加勒海事博物馆",
  galleBeach: "在乌纳瓦图纳海滩时光",
  galleDining: "在堡垒餐厅用餐",
  galleDay2Description: "在加勒的第二天进一步探索历史堡垒。",
  
  // Bentota
  day12Title: "本托塔",
  bentotaTitle: "本托塔",
  bentotaStay: "本托塔度假村",
  bentotaTransfer: "转至本托塔",
  bentotaRiver: "本托塔河游猎",
  bentotaBeach: "海滩活动",
  bentotaSpa: "水疗和健康护理",
  bentotaLocation: "本托塔海滩度假村",
  bentotaDescription: "在美丽的海滩度假村放松，享受河流活动。",
  
  // Colombo
  day13Title: "科伦坡",
  colomboTitle: "科伦坡",
  colomboStay: "科伦坡酒店",
  colomboTransfer: "转至科伦坡",
  colomboFort: "探索科伦坡堡",
  colomboTemple: "参观甘加拉马雅寺",
  colomboShopping: "在奥德尔和赤脚购物",
  colomboLocation: "科伦坡市",
  colomboDescription: "探索首都的景点和购物。",
  
  // Departure
  day14Title: "出发",
  departureTitle: "出发",
  departureStay: "机场酒店或出发",
  departureBreakfast: "最后早餐",
  departureShopping: "最后购物",
  departureTransfer: "转至机场",
  departureAirport: "从班达拉奈克国际机场出发",
  departureLocation: "班达拉奈克国际机场",
  departureDescription: "最后一天，转至机场并出发。",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "野生动物和文化遗产之旅",
  wildlifeCulturalCircuitSubtitle: "在这次全面的旅程中体验斯里兰卡的野生动物、古城和文化遗产。",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "乌达瓦拉维",
  udawalaweStay: "乌达瓦拉维野生动物园旅馆",
  udawalaweTransfer: "转至乌达瓦拉维",
  udawalaweSafari: "乌达瓦拉维国家公园野生动物园",
  udawalaweElephants: "大象观察和摄影",
  udawalaweBirds: "观鸟之旅",
  udawalaweLocation: "乌达瓦拉维国家公园",
  udawalaweDescription: "在自然栖息地中与大象、鸟类和其他动物一起体验斯里兰卡的野生动物。",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "埃拉",
  ellaWildlifeStay: "埃拉酒店",
  ellaWildlifeTransfer: "转至埃拉",
  ellaWildlifeTrain: "前往埃拉的风景火车之旅",
  ellaWildlifePeak: "小亚当峰徒步",
  ellaWildlifeBridge: "九拱桥观景点",
  ellaWildlifeLocation: "埃拉山站",
  ellaWildlifeDescription: "探索美丽的山区，欣赏壮丽的山景和茶园。",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "努沃勒埃利耶",
  nuwaraEliyaWildlifeStay: "努沃勒埃利耶酒店",
  nuwaraEliyaWildlifeTransfer: "转至努沃勒埃利耶",
  nuwaraEliyaWildlifeTea: "茶园和工厂之旅",
  nuwaraEliyaWildlifeLake: "格雷戈里湖乘船",
  nuwaraEliyaWildlifeExplore: "探索小英格兰",
  nuwaraEliyaWildlifeLocation: "努沃勒埃利耶茶乡",
  nuwaraEliyaWildlifeDescription: "体验小英格兰的凉爽气候和茶乡的魅力。",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "康提",
  kandyWildlifeStay: "康提酒店",
  kandyWildlifeTransfer: "转至康提",
  kandyWildlifeTemple: "佛牙寺",
  kandyWildlifeGardens: "皇家植物园",
  kandyWildlifeLake: "康提湖漫步",
  kandyWildlifeLocation: "佛牙寺",
  kandyWildlifeDescription: "拥有神圣遗产和郁郁葱葱花园的文化首都。",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "锡吉里耶",
  sigiriyaWildlifeStay: "锡吉里耶酒店",
  sigiriyaWildlifeTransfer: "转至锡吉里耶",
  sigiriyaWildlifeClimb: "攀登锡吉里耶岩石堡垒",
  sigiriyaWildlifeExplore: "探索水花园和壁画",
  sigiriyaWildlifeVillage: "村庄体验或自行车骑行（可选）",
  sigiriyaWildlifeLocation: "锡吉里耶岩石堡垒",
  sigiriyaWildlifeDescription: "具有全景景观的标志性联合国教科文组织世界遗产。",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "阿努拉达普拉",
  anuradhapuraWildlifeStay: "阿努拉达普拉酒店",
  anuradhapuraWildlifeTransfer: "转至阿努拉达普拉",
  anuradhapuraWildlifeExplore: "探索古代遗址和佛塔",
  anuradhapuraWildlifeTemple: "参观斯里马哈菩提树",
  anuradhapuraWildlifeMuseum: "参观考古博物馆",
  anuradhapuraWildlifeLocation: "阿努拉达普拉古城",
  anuradhapuraWildlifeDescription: "发现斯里兰卡的古代首都和联合国教科文组织世界遗产。",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "波隆纳鲁瓦",
  polonnaruwaStay: "波隆纳鲁瓦酒店",
  polonnaruwaTransfer: "转至波隆纳鲁瓦",
  polonnaruwaExplore: "探索古代遗址",
  polonnaruwaGalVihara: "参观伽尔维哈拉",
  polonnaruwaMuseum: "参观波隆纳鲁瓦博物馆",
  polonnaruwaLocation: "波隆纳鲁瓦古城",
  polonnaruwaDescription: "探索保存完好的遗址和雕塑的古代首都。",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "亭可马里",
  trincomaleeStay: "亭可马里酒店",
  trincomaleeTransfer: "转至亭可马里",
  trincomaleeBeach: "在尼拉韦利海滩放松",
  trincomaleeWhale: "观鲸之旅（季节性）",
  trincomaleeFort: "探索弗雷德里克堡",
  trincomaleeLocation: "尼拉韦利海滩，亭可马里",
  trincomaleeDescription: "享受美丽的海滩和观鲸机会。",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "科伦坡",
  colomboWildlifeStay: "科伦坡酒店",
  colomboWildlifeTransfer: "转至科伦坡",
  colomboWildlifeFort: "探索科伦坡堡",
  colomboWildlifeTemple: "参观甘加拉马亚寺",
  colomboWildlifeShopping: "在奥德尔和贝拉富特画廊购物",
  colomboWildlifeLocation: "科伦坡市",
  colomboWildlifeDescription: "探索首都的景点和购物。",
  
  // Wildlife Cultural Tour
  wildlifeCulturalTitle: "野生动物和文化遗产之旅",
  wildlifeCulturalType: "野生动物和文化",
  wildlifeCulturalHighlights: "亮点",
  wildlifeCulturalWildlife: "野生动物",
  wildlifeCulturalCulture: "文化",
  wildlifeCulturalHistory: "历史",
  wildlifeCulturalNature: "自然",
  
  // Hill Country Beach Tour
  hillCountryBeachTitle: "山区和海滩之旅",
  hillCountryBeachType: "山区和海滩",
  hillCountryBeachHighlights: "亮点",
  hillCountryBeachNature: "自然",
  hillCountryBeachBeach: "海滩",
  hillCountryBeachCulture: "文化",
  hillCountryBeachAdventure: "冒险",
  
  // Cultural Triangle Beach Tour
  culturalTriangleBeachTitle: "文化三角区和海滩之旅",
  culturalTriangleBeachType: "文化三角区和海滩",
  culturalTriangleBeachHighlights: "亮点",
  culturalTriangleBeachCulture: "文化",
  culturalTriangleBeachHistory: "历史",
  culturalTriangleBeachBeach: "海滩",
  culturalTriangleBeachRelaxation: "放松",
  
  // Package 1
  package1Title: "套餐 1 - 斯里兰卡",
  package1Duration: "4晚5天",
  package1Charges: "仅包含酒店和交通费用",
  package1Hotel: "4星级酒店包含床位、晚餐和早餐",
  package1Price: "Starting From: USD 780\nper 2 persons",
  package1Day1: "第1天",
  package1Day1Activity1: "品纳瓦拉",
  package1Day1Activity2: "康提（康提舞）",
  package1Day2: "第2天",
  package1Day2Activity1: "内利加勒",
  package1Day2Activity2: "康提寺庙",
  package1Day3: "第3天",
  package1Day3Activity1: "加达拉代尼亚、安巴克",
  package1Day3Activity2: "佩拉德尼亚花园",
  package1Day4: "第4天",
  package1Day4Activity1: "蜡像博物馆康提",
  package1Day4Activity2: "宝石、香料和蜡染购物",
  package1Activities: "活动",
  
  // Package 2
  package2Title: "套餐 2 - 斯里兰卡",
  package2Duration: "4晚5天",
  package2Charges: "仅包含酒店和交通费用",
  package2Hotel: "4星级酒店包含床位、晚餐和早餐",
  package2Price: "Starting From: USD 1130\nper 2 persons",
  package2Day1: "第1天",
  package2Day1Activity1: "品纳瓦拉",
  package2Day1Activity2: "康提寺庙",
  package2Day1Activity3: "康提舞",
  package2Day2: "第2天",
  package2Day2Activity1: "宝石、香料和蜡染购物",
  package2Day2Activity2: "佩拉德尼亚花园",
  package2Day2Activity3: "内利加勒",
  package2Day3: "第3天",
  package2Day3Activity1: "努沃勒埃利耶",
  package2Day3Activity2: "格雷戈里公园",
  package2Day4: "第4天",
  package2Day4Activity1: "安贝韦拉农场",
  package2Activities: "活动",
  
  // Package 3
  package3Title: "套餐 3 - 斯里兰卡",
  package3Duration: "4晚5天",
  package3Charges: "仅包含酒店和交通费用",
  package3Hotel: "4星级酒店包含床位、晚餐和早餐",
  package3Price: "Starting From: USD 895\nper 2 persons",
  package3Day1: "第1天",
  package3Day1Activity1: "品纳瓦拉",
  package3Day1Activity2: "康提寺庙",
  package3Day1Activity3: "康提舞",
  package3Day2: "第2天",
  package3Day2Activity1: "佩拉德尼亚花园",
  package3Day2Activity2: "内利加勒",
  package3Day2Activity3: "宝石、香料和蜡染购物",
  package3Day3: "第3天",
  package3Day3Activity1: "狮子岩",
  package3Day4: "第4天",
  package3Day4Activity1: "丹布勒寺庙",
  package3Day4Activity2: "丹布勒村庄寺庙",
  package3Activities: "活动",
  
  
  // Package tags
  hotel: "酒店",
  transport: "交通",
  cultural: "文化",
  shopping: "购物",
  hillCountry: "山区",
  teaPlantations: "茶园",
  sigiriya: "狮子岩",
  kandy: "康提",
  ella: "埃拉",
  mirissa: "米瑞莎",
  yala: "雅拉",
  galle: "加勒",
  colombo: "科伦坡",
  bentota: "本托塔",
  kitulgala: "基图尔格勒",
  arugamBay: "阿鲁甘湾",
  beach: "海滩",
  adventure: "冒险",
  heritageSites: "遗产地",
  safari: "野生动物园",
  wildlife: "野生动物",
  
  // Package titles (short version for cards)
  package1: "套餐 1",
  package2: "套餐 2",
  package3: "套餐 3",

  // Package 4
  package4Title: "Package 4 (Couples) - Sri Lanka",
  package4Duration: "5 nights 6 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Starting From: USD 990\nper 2 persons",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Package 4 (Couples)",

  // Package 5
  package5Title: "Package 5 - Sri Lanka",
  package5Duration: "6 nights 7 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Starting From: USD 1390\nper 2 persons",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Package 5",

};
